import { createActions, createReducer } from 'reduxsauce'

import ConsultaBensImoveisService from '../../servicos/ConsultaBensImoveisService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaBensImoveisInicio: [],
    buscaConsultaBensImoveisSucesso: ['consultaBensImoveis'],
    buscaConsultaBensImoveisErro: ['erro'],
    limpar: [],
    setConsultaBensImoveisEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaBensImoveis = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaBensImoveisInicio())
        let serv = new ConsultaBensImoveisService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaBensImoveisSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaBensImoveisErro(error)))
    }
}

const buscaConsultaBensImoveisInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaBensImoveisErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaBensImoveisSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaBensImoveis.resultado,
        dataSincronizacaoDados: action.consultaBensImoveis.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaBensImoveisEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_BENS_IMOVEIS_INICIO]: buscaConsultaBensImoveisInicio,
    [Types.BUSCA_CONSULTA_BENS_IMOVEIS_ERRO]: buscaConsultaBensImoveisErro,
    [Types.BUSCA_CONSULTA_BENS_IMOVEIS_SUCESSO]: buscaConsultaBensImoveisSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_BENS_IMOVEIS_ESTADO_DT]: setConsultaBensImoveisEstadoDT,
})
